import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGES]: {
		url: '/company/:companyId/api_usage/',
	},

	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE]: {
		url: '/company/:companyId/api_usage/:apiUsageId/',
	},

	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_PREVIEW]: {
		url: '/company/:companyId/api_usage/:apiUsageId/preview/',
	},

	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_POPUP]: {
		url: '/company/:companyId/api_usage/:apiUsageId/popup/',
	},

}